import React from 'react';
import './Simulation.css';
import bgImage from './PrinEco4_Production_Function_Base.png';

const SCR_W = 1000;
const SCR_H = 719;
/*const SCR_W = 570;
const SCR_H = 410;
const SCR_W_SCALE = SCR_W / ORIG_SCR_W;
const SCR_H_SCALE = SCR_H / ORIG_SCR_H;
const SCR_SCALE = (SCR_W_SCALE + SCR_H_SCALE) / 2;*/

const PERSONAL_SPACE = 16;
const FRICTION = 0.8;
const SPEED_PENALTY_TIME = 3;
const SPEED_PENALTY_FACTOR = 0.25;
const RANDOM_SPEED_FACTOR = 0;
const UNSTUCK_PROPORTION = 0.75;
const NEW_DOT_SPACE_MUL = 5;

//const FAST_FORWARD_SCALE = 240;

const MAX_MOVE_ITERS = 5;
const MAX_NAV_TIME = 20;
const FIXED_DT = 1 / 15;


/*
1 = 5 mph
3 = 10 mph
4 = 11 mph
5 = 13 mph
6 = 14 mph
7 = 14 mph
8 = 13 mph
9 = 13 mph
*/



const STATIONS = {
  "Start": {
    x: 900,
    y: 800,
    //x: 600,
    //y: 800,
    radius: 32,
    workTime: 0,
    // Only option: wash hands
    stationRoutes: {
      "Washing": ["Washing"], 
    }
  },
  "Washing": {
    x: 810,
    y: 365,
    radius: 32,
    workTime: 3,
    stationRoutes: {
      "Storage": ["Storage"],
      //"Food prep": ["Food prep"],
      //"Cooking": ["Cooking"],
    }
  },
  "Storage": {
    x: 860,
    y: 10,
    radius: 32,
    workTime: 3,
    stationRoutes: {
      "Cooking": ["Cooking right corner", "Cooking"],
      "Food prep": ["Food prep"],
    }
  },
  "Cooking right corner": {
    x: 700,
    y: 200,
    radius: 64,
    workTime: 0,
    stationRoutes: {
      "Cooking": ["Cooking"],
    }
  },
  "Cooking": {
    x: 210,
    y: 180,
    radius: 32,
    workTime: 4,
    stationRoutes: {
      "Food prep": ["Food prep"],
      "Storage": ["Cooking right corner", "Storage"],
    }
  },
  "Food prep": {
    x: 500,
    y: 550,
    radius: 32,
    workTime: 2,
    stationRoutes: {
      "Washing": ["Washing"],
      "Storage": ["Storage"],
      "Cooking": ["Cooking"],
      //"Exit": ["Food prep left corner", "Exit"],
    }
  },
  "Food prep left corner": {
    x: 250,
    y: 550,
    radius: 32,
    workTime: 0,
    stationRoutes: {
      "Exit": ["Exit"],
    }
  },
  /*"Exit": {
    x: 32,
    y: 800,
    radius: 32,
    workTime: 0,
    stationRoutes: {
      "Start": ["Start"],
    }
  }*/
}

const COLLIDERS = [
  {
    x: 0,
    y: 0,
    w: 680,
    h: 140,
  },
  {
    x: 0,
    y: 140,
    w: 138,
    h: 225,
  },
  {
    x: 868,
    y: 208,
    w: 138,
    h: 298,
  },
  {
    x: 268,
    y: 588,
    w: 452,
    h: 140,
  },
  /*{
    x: 400,
    y: 300,
    w: 200,
    h: 200,
  },*/
]

function len2(arr) {
  let sum = 0;
  for (let i = 0; i < arr.length; ++i) {
    sum += arr[i] * arr[i];
  }
  return sum;
}


function length(arr) {
  return Math.sqrt(len2(arr));
}

function normalize(arr) {
  let len = length(arr);
  if (len !== 0) {
    for (let i = 0; i < arr.length; ++i) {
      arr[i] /= len;
    }
  }
  return arr;
}

function negate(arr) {
  for (let i = 0; i < arr.length; ++i) {
    arr[i] = -arr[i];
  }
  return arr;
}

function scale(arr, x) {
  for (let i = 0; i < arr.length; ++i) {
    arr[i] *= x;
  }
  return arr;
}

function add(arr, arr2) {
  for (let i = 0; i < arr.length; ++i) {
    arr[i] += arr2[i];
  }
  return arr;
}

function dotP(arr, arr2) {
  let sum = 0;
  for (let i = 0; i < arr.length; ++i) {
    sum += arr[i] * arr2[i];
  }
  return sum;
}

function drawDot(ctx, dot) {
  let leader = false
  if (dot.queuePosition === 0) {
    if (dot.targetStations.length > 1) {
      let nextStation = STATIONS[dot.targetStations[1]];
      if (nextStation.queue.length === 0) {
        leader = true
      }
    } else {
      leader = true
    }
  }
  ctx.beginPath();
  ctx.strokeStyle = !leader ? dot.color : dot.colorLeader;
  ctx.fillStyle = !leader ? dot.fillColor : dot.fillColorLeader;
  ctx.lineWidth = 8;
  ctx.arc(dot.x, dot.y, dot.radius - dot.stroke / 2, 0, Math.PI * 2);
  ctx.fill();
  ctx.stroke();
}

function drawArrow(ctx, from, to, style) {
  let delta = [to[0] - from[0], to[1] - from[1]];
  normalize(delta);
  scale(delta, -10);
  let right = [delta[1], -delta[0]];
  ctx.beginPath();
  ctx.moveTo(...from);
  ctx.lineTo(...to);
  let d1 = add(right.slice(), delta);
  let d2 = add(negate(right.slice()), delta);
  ctx.lineTo(...add(d1, to));
  ctx.moveTo(...to);
  ctx.lineTo(...add(d2, to));
  ctx.strokeStyle = style;
  ctx.lineWidth = 2;
  ctx.stroke();
}


let renderIter = 0
let timesToRender = 0
let renderTimeScale = 1
let debugMode = false
let running = false
let restartTimeout
function beginRender(ref, bg, numWorkers, _setRenderTs, productionMode, state, newTextEvents) {
  //console.log("beginRender called")
  if (running) {
    ++renderIter;
    //console.log("beginRender restart ++renderIter = ", renderIter);
    window.clearTimeout(restartTimeout);
    restartTimeout = window.setTimeout(()=>{
      //console.log("beginRender timeout recursive call")
      beginRender(ref, bg, numWorkers, _setRenderTs, productionMode, state, newTextEvents);
    }, 1);
    return;
  }
  running = true;

  let myRenderIter = renderIter;
  let myRefCurrent = ref.current;
  //console.log("beginRender myRenderIter =", myRenderIter)

  let dots = state.dots ?? []
  let burgers = state.burgers ?? []
  let dtTotalFixed = state.dtTotalFixed ?? 0;
  let didAutoFFOff = false;
  let textEvents = (newTextEvents ?? []).map(i => ({
    time: i.time * 4 + dtTotalFixed,
    text: i.text,
  }))

  if (!state.dots) {
    // Initial state
    state.dots = dots;
    state.burgers = burgers;
    for (const property in STATIONS) {
      STATIONS[property].queue = [];
    }
  }

  //console.log("adding/removing", myRenderIter)

  let startDots = dots.length;
  for (let i = dots.length; i < numWorkers; ++i) {
    //console.log("add dot", STATIONS["Washing"].queue)
    dots.push({
      targetStations: ["Washing"],
      timeStartedTraveling: dtTotalFixed,
      queuePosition: STATIONS["Washing"].queue.length,
      index: i,
      x: STATIONS["Start"].x,
      y: STATIONS["Start"].y + 86 * (i - startDots) * NEW_DOT_SPACE_MUL,
      vx: 0,
      vy: 0,
      radius: 36,
      stroke: 6,
      speed: 15 + Math.random() * RANDOM_SPEED_FACTOR,
      color: '#c04040',
      colorLeader: '#4040c0',
      fillColor: '#ff808040',
      fillColorLeader: '#8080ff40',
      burgerStage: 0,
    })
    STATIONS["Washing"].queue.push(i);
  }

  for (const property in STATIONS) {
    let adjust = 0;
    for (let j = 0; j < STATIONS[property].queue.length; ++j) {
      if (STATIONS[property].queue[j] >= numWorkers) {
        //console.log(property, STATIONS[property].queue[j], "removed one from queue")
        STATIONS[property].queue.splice(j, 1);
        --j;
        --adjust;
      } else {
        dots[STATIONS[property].queue[j]].queuePosition += adjust;
        //console.log(property, STATIONS[property].queue[j], "adjusted", adjust)
      }
    }
  }
  
  dots.splice(numWorkers, dots.length - numWorkers)

  function moveDot(dot, [x, y], r) {
    if (r && r > MAX_MOVE_ITERS) return;
    dot.x += x;
    dot.y += y;
    // Alternate between colliding dots and rectangles each iteration
    for (let i = 0; i < 2; ++i) {
      let j = (i + (r ?? 0)) % 2;
      switch (j) {
        case 0:
          for (const {x, y, w, h} of COLLIDERS) {
            // Line segments in clockwise order
            for (const [[fx, fy], [tx, ty], maxDepth] of [
              [[x, y], [x + w, y], h], // tl -> tr
              [[x + w, y], [x + w, y + h], w], // tr -> br
              [[x + w, y + h], [x, y + h], h], // br -> bl
              [[x, y + h], [x, y], w], // bl -> tl
            ]) {
              let seg = [tx - fx, ty - fy];
              let seg2 = [fx - tx, fy - ty];
              let n = [seg[1], -seg[0]];
              normalize(n);
              normalize(seg);
              normalize(seg2);
              let delta = [dot.x - fx, dot.y - fy];
              let delta2 = [dot.x - tx, dot.y - ty];
              let distN = dotP(n, delta) - dot.radius;
              let distS = dotP(seg, delta);
              let distE = dotP(seg2, delta2);
              if (distN < 0 && distN > -maxDepth && (distS < 0) === (distE < 0)) {
                //debugger;
                scale(n, -distN);
                return moveDot(dot, n, (r ?? 0) + 1);
              }
              let len2S = len2(delta);
              if (len2S < dot.radius * dot.radius) {
                let backoff = dot.radius - Math.sqrt(len2S);
                normalize(delta);
                scale(delta, backoff);
                return moveDot(dot, delta, (r ?? 0) + 1); 
              }
              // Don't need to account for delta2 because the next loop iteration will take care of that
            }
          }
          break;
        case 1:
          for (const odot of dots) {
            if (odot === dot) continue;
            let delta = [odot.x - dot.x, odot.y - dot.y];
            let dLen2 = len2(delta);
            let minLen = (dot.radius + odot.radius);
            
            if (minLen * minLen - dLen2 > 0) {
              // We overlapped. Move `pen` units away from the other unit.
              //console.log("overlap", r, pen);
              let pen = minLen - Math.sqrt(dLen2);
              normalize(delta);
              let right = [delta[1], -delta[0]];
              scale(right, UNSTUCK_PROPORTION);
              add(delta, right);
              normalize(delta);
              scale(delta, -pen);
              dot.speedPenaltyTime = dtTotalFixed;
              odot.speedPenaltyTime = dtTotalFixed;
              // There are a lot of dots to collide with so don't stop the iteration
              moveDot(dot, delta, (r ?? 0) + 1);
            }
          }
          break;
        default:
      }
    }
  }

  function accelDot(dot, [x, y]) {
    let speed = dot.speed
    if (dtTotalFixed - dot.speedPenaltyTime < SPEED_PENALTY_TIME) {
      speed *= SPEED_PENALTY_FACTOR;
    }
    dot.vx = dot.vx * FRICTION + x * speed * FIXED_DT;
    dot.vy = dot.vy * FRICTION + y * speed * FIXED_DT;
    moveDot(dot, [dot.vx, dot.vy]);
  }

  //let lastTime = performance.now();
  //let dtAvg = new Array(4).fill(0);
  //let dtAvgIndex = 0;
  

  function render(time) {
    //let dt = time - lastTime;
    //lastTime = time;

    /*dtAvg[dtAvgIndex++] = dt;
    if (dtAvgIndex >= dtAvg.length) {
      dtAvgIndex = 0;
    }

    let avgDt = 0
    for (let i = 0; i < dtAvg.length; ++i) {
      avgDt += dtAvg[i];
    }
    avgDt /= dtAvg.length;*/
    if (myRefCurrent !== ref.current) {
      ++renderIter
      //console.log("render myRefCurrent !== ref.current EARLY; ++renderIter =", renderIter)
    }
    if (myRenderIter !== renderIter) {
      //console.log("Shutting down EARLY", myRenderIter, renderIter);
      state.dtTotalFixed = dtTotalFixed;
      running = false;
      return;
    }

    let ctx = ref.current.getContext('2d', { alpha: false })
    if (bg.current && bg.current.complete) {
      timesToRender += renderTimeScale;
      while (timesToRender > 0) {
        --timesToRender;
        dtTotalFixed += FIXED_DT;
        if (timesToRender <= 0) {
          ctx.drawImage(bg.current, 0, 0, SCR_W, SCR_H);
        }
        if (timesToRender <= 0 && !productionMode) {
          ctx.font = '24px serif';
          ctx.fillStyle = 'blue'
          ctx.textBaseline = "top"
          //ctx.fillText("dt: " + avgDt.toFixed(2), 0, 0);
          let hour = Math.floor(dtTotalFixed / (60 * 60));
          let minute = Math.floor((dtTotalFixed - hour * 60 * 60) / 60);
          let second = Math.floor((dtTotalFixed - hour * 60 * 60 - minute * 60));
          ctx.fillText(`Time: ${hour}:${minute.toString().padStart(2, "0")}:${second.toString().padStart(2, "0")}`, 0, 100);
        }
        if (timesToRender <= 0 && debugMode) {
          for (const station in STATIONS) {
            STATIONS[station].color = "#eeeeee80"
            STATIONS[station].fillColor = "#ffffff80"
            STATIONS[station].stroke = 4
            drawDot(ctx, STATIONS[station]);
          }
          for (const {x, y, w, h} of COLLIDERS) {
            ctx.beginPath();
            ctx.fillStyle = "#ff000080"
            ctx.fillRect(x, y, w, h);
          }
        }
        for (let i = 0; i < dots.length; ++i) {
          const dot = dots[i];
          let station = STATIONS[dot.targetStations[0]];
          let nextStation = STATIONS[dot.targetStations[1]];
          
          if (!station) {
            throw new Error("No next station! " + i + ", " + dot.targetStations);
          }
          if (nextStation) {
            let dStation = [station.x - dot.x, station.y - dot.y];
            let dNextStation = [nextStation.x - dot.x, nextStation.y - dot.y];
            if (len2(dNextStation) < len2(dStation)) {
              console.log("Skipping from", dot.targetStations[0], "to", dot.targetStations[1]);
              station.queue.splice(dot.queuePosition, 1);
              for (let j = dot.queuePosition; j < station.queue.length; ++j) {
                dots[station.queue[j]].queuePosition--;
              }
              let newIndex = nextStation.queue.length;
              nextStation.queue.push(i);
              dot.queuePosition = newIndex;
              dot.targetStations.shift();
              station = nextStation;
            }
          }
          if (station.queue[dot.queuePosition] !== i) {
            throw new Error(`Queue position queue[${dot.queuePosition}] -> ${station.queue[dot.queuePosition]} did not match current dot index ${i}`, dot, station)
          }
          let dotInFront = dots[station.queue[dot.queuePosition - 1]];
          
          let canMoveToStation = false;
  
          if (dotInFront) {
            //console.log(i, "dotInFront", dotInFront)
            if (timesToRender <= 0 && debugMode) {
              drawArrow(ctx, [dot.x, dot.y], [dotInFront.x, dotInFront.y], 'red');
            }
            let nextDotCoords = [dotInFront.x - dot.x, dotInFront.y - dot.y];
            // If there's enough space in front of us
            let minDist = (dot.radius + dotInFront.radius + PERSONAL_SPACE);

            let nextDotBackoff = scale(normalize(nextDotCoords.slice()), -minDist);
            add(nextDotCoords, nextDotBackoff);
            let nextDotLen = length(nextDotCoords);
            normalize(nextDotCoords);
            if (nextDotLen < dot.speed) {
              scale(nextDotCoords, 1 / dot.speed)
            }
            accelDot(dot, nextDotCoords);
            /*
            let dist2 = len2(nextDotCoords);
            if (dist2 > minDist * minDist) {
              // Follow the leader
              normalize(nextDotCoords);
              accelDot(dot, nextDotCoords);
            } else {
              // Find out if we should back up
              let dist = Math.sqrt(dist2);
              let toomuch = minDist - dist;
              let backoff = normalize(nextDotCoords.slice());
              scale(backoff, -toomuch * PERSONAL_FORCE_SCALE);
              add(backoff, nextDotCoords);
              accelDot(dot, backoff);
            }
            */
            dot.timeStartedTraveling = dtTotalFixed;
          } else {
            canMoveToStation = true;
          }
          if (canMoveToStation) {
            //console.log(i, "canMoveToStation")
            if (timesToRender <= 0 && debugMode) {
              drawArrow(ctx, [dot.x, dot.y], [station.x, station.y], 'blue');
            }
            let targetCoords = [station.x - dot.x, station.y - dot.y];
            // If we're at the station
            if (len2(targetCoords) < station.radius * station.radius) {
              if (dot.timeStartedTraveling) {
                dot.timeStartedTraveling = undefined
              }
              if (dot.timeStartedWorking) {
                if (dtTotalFixed - dot.timeStartedWorking > station.workTime) {
                  // Stop working...
                  if (dot.queuePosition !== 0) {
                    throw new Error("Dot " + i + " tried to cut in line (queue index " + dot.queuePosition + ")");
                  }
                  dot.timeStartedWorking = undefined;
                  station.queue.shift();
                  for (let j = 0; j < station.queue.length; ++j) {
                    let did = station.queue[j];
                    //console.log("queue loop", did, dots[did]);
                    dots[did].queuePosition--;
                  }
  
                  if (dot.targetStations[0] === "Storage" && dot.burgerStage === 0) {
                    dot.burgerStage = 1
                  }
                  if (dot.targetStations[0] === "Cooking" && dot.burgerStage === 1) {
                    dot.burgerStage = 2
                  }
                  if (dot.targetStations[0] === "Food prep" && dot.burgerStage === 2) {
                    dot.burgerStage = 0
                    burgers.push(dtTotalFixed);
                  }
  
                  dot.targetStations.shift();
                  // ...and move to the next station
                  if (dot.targetStations[0] === undefined) {
                    // Find a new route if needed
                    let availStations = Object.keys(station.stationRoutes);
                    let nextMainStation = availStations[Math.floor(Math.random() * availStations.length)];
                    //console.log("dot", i, "nextMainStation", nextMainStation);
    
                    dot.targetStations = station.stationRoutes[nextMainStation].slice();
                    dot.timeStartedTraveling = dtTotalFixed;
                  }
                  
                  dot.queuePosition = STATIONS[dot.targetStations[0]].queue.length;
                  STATIONS[dot.targetStations[0]].queue.push(i);
                }
              } else {
                // Start working
                dot.timeStartedWorking = dtTotalFixed;
              }
              accelDot(dot, [0, 0]);
            } else {
              if (dot.queuePosition === 0 && dtTotalFixed - dot.timeStartedTraveling > MAX_NAV_TIME) {
                console.log("stuck");

                station.queue.sort((a, b) => {
                  let alen = len2([station.x - dots[a].x, station.y - dots[a].y]);
                  let blen = len2([station.x - dots[b].x, station.y - dots[b].y]);
                  if (alen < blen) {
                    return -1;
                  }
                  if (alen > blen) {
                    return 1;
                  }
                  return 0;
                })
                let changed = false
                for (let j = 0; j < station.queue.length; ++j) {
                  let old = dots[station.queue[j]].queuePosition
                  //console.log("resort", old, "-->", j);
                  if (old !== j) {
                    changed = true
                  }
                  dots[station.queue[j]].queuePosition = j;
                  dots[station.queue[j]].timeStartedTraveling = dtTotalFixed;
                }
                if (false && !changed) {
                  console.log("Stuck resort didn't help");
                  // We're stuck for good. Everybody wash hands?
                  let newStation = STATIONS["Washing"];
                  if (newStation !== station) {
                    for (let j = 0; j < station.queue.length; ++j) {
                      let newIndex = newStation.queue.length;
                      let dotId = station.queue[j];
                      newStation.queue.push(dotId);
                      dots[dotId].queuePosition = newIndex;
                      dots[dotId].targetStations = ["Washing"];
                    }
                    station.queue = [];
                    newStation.queue.sort((a, b) => {
                      let alen = len2([newStation.x - dots[a].x, newStation.y - dots[a].y]);
                      let blen = len2([newStation.x - dots[b].x, newStation.y - dots[b].y]);
                      if (alen < blen) {
                        return -1;
                      }
                      if (alen > blen) {
                        return 1;
                      }
                      return 0;
                    })
                    for (let j = 0; j < newStation.queue.length; ++j) {
                      let dotId = newStation.queue[j];
                      dots[dotId].queuePosition = j;
                      dots[dotId].timeStartedTraveling = dtTotalFixed;
                    }
                    console.log("washing time");
                  }
                }
              }
              normalize(targetCoords);
              accelDot(dot, targetCoords);
            }
          }
          if (timesToRender <= 0) {
            drawDot(ctx, dot)
          }
        }
        if (timesToRender <= 0 && !productionMode) {
          let numMealsLastHour = 0
          for (let i = burgers.length - 1; i >= 0; --i) {
            let age = dtTotalFixed - burgers[i];
            if (age < 60 * 60) {
              ++numMealsLastHour;
            }
          }
          ctx.font = '48px sans-serif'
          ctx.fillStyle = dtTotalFixed < 60 * 60 ? 'yellow' : 'blue'
          ctx.fillText("Meals per hour: " + (numMealsLastHour * 5 / 55).toFixed(1), 0, 12);
        }
        if (timesToRender <= 0 && textEvents.length > 0) {
          ctx.font = '48px sans-serif'
          ctx.fillStyle = 'yellow'
          ctx.lineWidth = 4
          ctx.strokeStyle = 'black'
          //ctx.textAlign = 'right'

          let text = "# meals per hour: ";
          let text2 = "";
          for (let i = 0; i < textEvents.length; ++i) {
            if (dtTotalFixed > textEvents[i].time) {
              text2 = textEvents[i].text
            }
          }

          text += text2;
          ctx.strokeText(text, 420, 40);
          ctx.fillText(text, 420, 40);
        }
        if (dtTotalFixed > 60 * 60 && !didAutoFFOff) {
          didAutoFFOff = true;
          renderTimeScale = 1;
          _setRenderTs(1);
          console.log("did off");
        }
      }
    }
    if (myRefCurrent !== ref.current) {
      ++renderIter
      //console.log("render myRefCurrent !== ref.current; ++renderIter =", renderIter)
    }
    if (myRenderIter !== renderIter) {
      //console.log("Shutting down", myRenderIter, "for", renderIter);
      state.dtTotalFixed = dtTotalFixed;
      running = false;
      return;
    }
    requestAnimationFrame(render);
  }
  if (myRenderIter === renderIter) {
    requestAnimationFrame(render);
  }
}

function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = React.useState(false)
  const observer = React.useMemo(() => {
    return new IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting)
    )
  }, [])
  React.useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current)
    }
    // Remove the observer as soon as the component is unmounted
    return () => { observer.disconnect() }
  }, [observer, ref])

  return isIntersecting
}

//let didFF = false;
function Simulation({numWorkers, timescale, debug, state, newTextEvents, ariaDescribedBy}) {
  const canvas = React.useRef(null);
  const bg = React.useRef(null);
  //const [_renderTs, _setRenderTs] = React.useState(timescale);
  const visible = useOnScreen(canvas)
  let productionMode = !debug


  React.useEffect(() => {
    //console.log("canvas", canvas.current);
    if (!visible || !canvas.current.getContext) {
      return;
    }
    let ctx = canvas.current.getContext('2d');
    if (ctx) {
      //console.log("Begin with", numWorkers, "workers", canvas);
      renderTimeScale = timescale;
      beginRender(canvas, bg, numWorkers, ()=>{}, productionMode, state, newTextEvents);
    }
    return () => {
      //++renderIter
      //console.log("Canvas unmount ++renderIter = ", renderIter)
    }
  }, [numWorkers, timescale, productionMode, visible, state, newTextEvents]);
  return (
    <div className="App">
      <canvas 
        ref={canvas} 
        className="canvas" 
        width={SCR_W} 
        height={SCR_H}
        aria-describedby={ariaDescribedBy}
      >
        <span aria-hidden="true">Your browser does not support the &lt;canvas&gt; element.</span>
      </canvas>
      <div className='hidden'>
        <img ref={bg} src={bgImage} alt=""/>
      </div>
    </div>
  );
}

export default Simulation;
